// v1's namebar: "You are <name>" + change (re-opens the name gate), Enable alerts
// (push opt-in), Log out. Change/alerts are phone-only — the owner's desktop doesn't
// need per-tech controls (v1 CSS rule, carried).
import { canEnablePush, enablePush } from '../lib/push';
import { signOutDevice } from '../state/admin';
import { techName } from '../state/session';
import { toast } from '../state/toast';

export function NameBar() {
  function changeName() {
    techName.value = '';
    localStorage.removeItem('techName'); // the name gate reappears; check-in follows
  }

  return (
    <div class="mx-auto flex max-w-3xl flex-wrap items-center gap-x-2 gap-y-1 px-3 py-1.5 text-xs text-slate-500">
      <span>
        You are <b class="text-navy-900">{techName.value || '(not set)'}</b>
      </span>
      <button
        class="tap !min-h-0 rounded px-1 py-0.5 font-semibold text-brand-700 lg:hidden"
        onClick={changeName}
      >
        change
      </button>
      {canEnablePush.value && (
        <button
          class="tap !min-h-0 flex items-center gap-1 rounded-full border border-slate-300 bg-white px-2 py-0.5 font-semibold text-navy-900 lg:hidden"
          data-testid="btn-enable-push"
          onClick={async () => toast(await enablePush(techName.value))}
        >
          <svg viewBox="0 0 24 24" class="h-3.5 w-3.5" fill="currentColor" aria-hidden="true">
            <path d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
          </svg>
          Enable alerts
        </button>
      )}
      <button
        class="tap !min-h-0 ml-auto rounded px-1 py-0.5 font-semibold"
        data-testid="btn-logout"
        title="Log out — re-enter the access code"
        onClick={() => {
          if (confirm('Log out on this device? You will need an access code to get back in.'))
            void signOutDevice();
        }}
      >
        Log out
      </button>
    </div>
  );
}
